<template>
  <div>
    <div class="button-prev" @click="swiperChange('prev')">
      <img src="../assets/images/up.jpg" alt="" />
    </div>
    <div v-swiper:mySwiper="swiperOption">
      <div class="swiper-wrapper">
        <div class="swiper-slide box clearfix" @click="toDetail(item)" v-for="(item, index) in list" :key="index">
          <div class="swiper_bater">
            <img :src="item.headUrl" alt="" />
          </div>
          <div class="export_desc">
            <p>{{item.name}}</p>
             <div>{{item.expertDes}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-next" @click="swiperChange('next')">
      <img src="../assets/images/down.jpg" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        direction: "vertical", //设置竖向轮播
      },
      currPage:1
    };
  },
  methods: {
    toDetail(item){
      this.$router.push({
        path:"/expert_detail",
        query:{id:item.userId}
      })
    },
    //切换轮播图
    swiperChange(type) {
      switch (type) {
        case "prev":
          this.mySwiper.slidePrev();
          break;

        default:
          this.mySwiper.slideNext();
          if(this.mySwiper.slideNext() == false){
             this.currPage ++;
             this.$emit('onExpert',this.currPage)
          }
          break;
      }
    },
  },
};
</script>
<style scoped>
.swiper-container {
  height: 300px;
  border-right: 1px solid #eeeeee;
  border-left: 1px solid #eeeeee;
  padding: 0 10px;
}
.button-prev,
.button-next {
  width: 100%;
  line-height: 20px;
  text-align: center;
  background: linear-gradient(-79deg, #ff7602, #ffc602);
}
.button-prev,.button-next:hover{
  cursor: pointer;
}
.swiper-wrapper .box {
  width: 248px;
  cursor: pointer;
  padding-top: 15px;
}
.export_desc {
  margin-left: 10px;
   width: 168px;
  text-align: left;
  float: right;
  padding-top: 4px;
}
.export_desc p:nth-child(1) {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-bottom: 5px;
}
.export_desc div {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  /* width: 98%; */
  /*多行溢出省略 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 37px;
}
.swiper_bater img {
  width: 100%;
}
.swiper_bater{
  width: 70px;
  height: 70px;
  border-radius: 100%;
  float: left;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/common/swiperItem.vue